import { render, staticRenderFns } from "./ConfirmPrimary.vue?vue&type=template&id=0ef2cd08&"
import script from "./ConfirmPrimary.vue?vue&type=script&lang=js&"
export * from "./ConfirmPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports